// Fuente del inventario: pestaña "VEHICULOS" de la planilla "base de datos VCARS".
// Si publicás solo esa pestaña (Archivo → Compartir → Publicar en la web → CSV),
// pegá ese enlace en publishedCsvUrl: tiene prioridad y permite dejar la planilla privada.
export const inventorySource = {
  spreadsheetId: '1zg4BJxd_A_7py4qV4gZYnfxhS1r-G7MRUG0re0GOgPk',
  sheetName: 'VEHICULOS',
  publishedCsvUrl: '',
};
